import { AxiosResponse } from "axios";
import React from "react";
import $ from "jquery";
import ReactDOM from "react-dom";
import { parseQueryResponseOnFail, parseQueryResponseOnFailResponse, usePickPropsIfNotNull } from "../../../declarations/common_utils";
import { IDataRepr } from "../../../intelws_portal/constructs/elements/Table";
import ModalFooter from "../../../intelws_portal/constructs/modal/ModalFooter";
import ModalHeader from "../../../intelws_portal/constructs/modal/ModalHeader";
import ModalInputText from "../../../intelws_portal/constructs/modal/ModalInputText";
import { get, getCancelToken, post } from "../../../intelws_portal/utils/backendInterface";
import { IConfigListElement } from "../admin/AdminSettings";

interface IPostAddLeadStatus extends AxiosResponse {
    data: {
        data: IConfigListElement
    }
}

interface IModalLeadStatusConfigurationAdd {
    leadStatusId: number,
    leadStatusName: string,
    mutator: (data: IConfigListElement) => void
}

function ModalLeadStatusConfigurationAdd(props: IModalLeadStatusConfigurationAdd) {
    const ENDPOINT = "api/settings/";

    const [errorObj, setErrorObj] = React.useState(getEmptyErrorObj);
    const [leadStatusName, setLeadStatusName] = React.useState("");
    const cancelTokenSource = React.useRef(getCancelToken());
    const [disable, setDisable] = React.useState(true);
   
    React.useEffect(() => {
        $("#leadStatusConfigurationAddModal").on("hidden.bs.modal", clearForm)
        return () => {
            cancelTokenSource.current.cancel();
            $("#leadStatusConfigurationAddModal").off("hidden.bs.modal");
        }
    }, [])

    React.useEffect(() => {
        setLeadStatusName(props.leadStatusName);
    }, [props.leadStatusName])

    React.useEffect(() => {
        if (leadStatusName != "") {
            setDisable(false);
        } else {
            setDisable(true);
        }
    }, [leadStatusName])

    function clearForm() {
        setErrorObj(getEmptyErrorObj);
        setLeadStatusName("");
    }

    function getEmptyErrorObj() {
        return {
            lead_status_name: {
                isError: false,
                errorText: ""
            }
        }
    }

    function submitForm() {
        let formData = new FormData();
        formData.append("lead_status_name", leadStatusName);
        if (props.leadStatusId != -1) {
            formData.append("lead_status_id", props.leadStatusId.toString());
        }

        const requestResponse = post(ENDPOINT, formData, cancelTokenSource.current.token, { section: "add_lead_status_name"} ) as Promise<IPostAddLeadStatus>
        requestResponse.then((response) => {
            props.mutator(response.data.data);
            $("#leadStatusConfigurationAddModal").modal("hide");
        }).catch((error) => {
            let [success, fail, failResponse] = parseQueryResponseOnFail(error);
            let errorObj = getEmptyErrorObj();
            parseQueryResponseOnFailResponse(errorObj, failResponse);
            setErrorObj(errorObj);
        })
    }

    function formFieldChange(e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement> , section: "leadStatusName") {
        if (section == "leadStatusName") {
            setLeadStatusName(e.target.value);
        }
    }
    
    function relativeRender() {
        return (
            <div className="modal fade custom-modal text-center" id="leadStatusConfigurationAddModal" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog text-left modal-lg" role="document">
                    <div className="modal-content">
                        <ModalHeader title={"Add Lead Status"} />
                        <div className="modal-body">
                            <ModalInputText onChange={(e) => formFieldChange(e, "leadStatusName")} value={leadStatusName} title={"Lead Status Name"}
                                required borderBottom isError={errorObj.lead_status_name.isError} errorText={errorObj.lead_status_name.errorText} /> <br />
                        </div>
                        <ModalFooter saveCallback={submitForm} saveInactive={false} disable={disable}/>
                    </div>
                </div>
            </div>
        )
    }

    return ReactDOM.createPortal(relativeRender(), document.getElementById('modal') as Element);
}

export default ModalLeadStatusConfigurationAdd;